// Module
var code = "<script>let $ctrl</script> <organism-wizard-confirm-view ng-if=\"!$ctrl.isLoading\" service-wizard-confirm=\"$ctrl.emailWizardConfirmation\" wizard-create-object-list=\"$ctrl.wizardCreateObjectList\"></organism-wizard-confirm-view> ";
// Exports
module.exports = code;